function IconRemote(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 159.501 159.501"
      {...props}
    >
      <g transform="translate(-1079 -471)">
        <g transform="translate(1079 471)" fill="none">
          <path
            d="M79.75,0A79.75,79.75,0,1,1,0,79.75,79.75,79.75,0,0,1,79.75,0Z"
            stroke="none"
          />
          <path
            d="M 79.75048828125 3.999984741210938 C 69.5224609375 3.999984741210938 59.6025390625 6.002273559570312 50.26620483398438 9.951202392578125 C 45.77853393554688 11.84931945800781 41.44986724853516 14.19889831542969 37.40046691894531 16.93460083007812 C 33.38848876953125 19.64506530761719 29.61566162109375 22.7579345703125 26.18679809570312 26.18679809570312 C 22.7579345703125 29.61566162109375 19.64506530761719 33.38848876953125 16.93460083007812 37.40046691894531 C 14.19889831542969 41.44986724853516 11.84931945800781 45.77853393554688 9.951202392578125 50.26620483398438 C 6.002273559570312 59.6025390625 3.999984741210938 69.5224609375 3.999984741210938 79.75048828125 C 3.999984741210938 89.978515625 6.002273559570312 99.8984375 9.951202392578125 109.2347717285156 C 11.84931945800781 113.7224426269531 14.19889831542969 118.0510864257812 16.93460083007812 122.1005096435547 C 19.64506530761719 126.1124877929688 22.7579345703125 129.8852996826172 26.18679809570312 133.3141479492188 C 29.61566162109375 136.7430114746094 33.38848876953125 139.8559112548828 37.40046691894531 142.5663452148438 C 41.44986724853516 145.3020782470703 45.77853393554688 147.6516265869141 50.26620483398438 149.5497436523438 C 59.6025390625 153.4986724853516 69.5224609375 155.5009613037109 79.75048828125 155.5009613037109 C 89.978515625 155.5009613037109 99.8984375 153.4986724853516 109.2347717285156 149.5497436523438 C 113.7224426269531 147.6516265869141 118.0511016845703 145.3020782470703 122.1005096435547 142.5663452148438 C 126.1124877929688 139.8559112548828 129.8852996826172 136.7430114746094 133.3141479492188 133.3141479492188 C 136.7430114746094 129.8852996826172 139.8559112548828 126.1124877929688 142.5663452148438 122.1005096435547 C 145.3020782470703 118.0511016845703 147.6516265869141 113.7224426269531 149.5497436523438 109.2347717285156 C 153.4986724853516 99.8984375 155.5009613037109 89.978515625 155.5009613037109 79.75048828125 C 155.5009613037109 69.5224609375 153.4986724853516 59.6025390625 149.5497436523438 50.26620483398438 C 147.6516265869141 45.77853393554688 145.3020782470703 41.44986724853516 142.5663452148438 37.40046691894531 C 139.8559112548828 33.38848876953125 136.7430114746094 29.61566162109375 133.3141479492188 26.18679809570312 C 129.8852996826172 22.7579345703125 126.1124877929688 19.64506530761719 122.1005096435547 16.93460083007812 C 118.0510864257812 14.19889831542969 113.7224426269531 11.84931945800781 109.2347717285156 9.951202392578125 C 99.8984375 6.002273559570312 89.978515625 3.999984741210938 79.75048828125 3.999984741210938 M 79.75048828125 -1.52587890625e-05 C 123.7954635620117 -1.52587890625e-05 159.5009613037109 35.70551300048828 159.5009613037109 79.75048828125 C 159.5009613037109 123.7954635620117 123.7954635620117 159.5009613037109 79.75048828125 159.5009613037109 C 35.70551300048828 159.5009613037109 -1.52587890625e-05 123.7954635620117 -1.52587890625e-05 79.75048828125 C -1.52587890625e-05 35.70551300048828 35.70551300048828 -1.52587890625e-05 79.75048828125 -1.52587890625e-05 Z"
            stroke="none"
            fill="#273aa5"
          />
        </g>
        <g transform="translate(1044.823 498.992)">
          <path
            d="M143.125,53.613h5.6a6.449,6.449,0,0,1,12.9,0h5.6a12.052,12.052,0,1,0-24.1,0Z"
            transform="translate(-41.016 -29.918)"
            fill="#273aa5"
          />
          <path
            d="M125.26,5.6A18.114,18.114,0,0,1,143.353,23.7h5.6a23.7,23.7,0,0,0-47.392,0h5.6A18.113,18.113,0,0,1,125.26,5.6Z"
            transform="translate(-11.099 0)"
            fill="#273aa5"
          />
          <path
            d="M86.146,114.582v72.2h56.031v-72.2Zm50.428,66.6H91.749V120.185h44.825Z"
            transform="translate(0 -82.481)"
            fill="#273aa5"
          />
          <rect
            width="19.611"
            height="5.603"
            transform="translate(105.757 51.711)"
            fill="#273aa5"
          />
          <rect
            width="11.206"
            height="5.603"
            transform="translate(100.154 65.719)"
            fill="#273aa5"
          />
          <rect
            width="11.206"
            height="5.603"
            transform="translate(116.963 65.719)"
            fill="#273aa5"
          />
          <rect
            width="11.206"
            height="5.603"
            transform="translate(100.154 79.727)"
            fill="#273aa5"
          />
          <rect
            width="11.206"
            height="5.603"
            transform="translate(116.963 79.727)"
            fill="#273aa5"
          />
        </g>
      </g>
    </svg>
  );
}

export default IconRemote;
